import { createRouter, createWebHistory, type Router } from "vue-router";
import HomePage from "./components/HomePage.vue";

export function createAppRouter(): Router {
  return createRouter({
    history: createWebHistory(),
    routes: [
      { path: "/", name: "home", component: HomePage },
      { path: "/signup", name: "signup", component: () => import("./pages/SignupPage.vue") },
      { path: "/verify-email", name: "verify-email", component: () => import("./pages/VerifyEmailPage.vue") },
      { path: "/login", name: "login", component: () => import("./pages/LoginPage.vue") },
      { path: "/forgot-password", name: "forgot-password", component: () => import("./pages/ForgotPasswordPage.vue") },
      { path: "/reset-password", name: "reset-password", component: () => import("./pages/ResetPasswordPage.vue") },
      { path: "/account", name: "account", component: () => import("./pages/AccountPage.vue") },
      { path: "/staff", redirect: { name: "staff-accounts" } },
      { path: "/staff/login", name: "staff-login", component: () => import("./pages/staff/StaffLoginPage.vue") },
      { path: "/staff/accounts", name: "staff-accounts", component: () => import("./pages/staff/StaffAccountsPage.vue") },
      // Placeholders until the published texts of s20-vitrine
      { path: "/privacy", name: "privacy", component: () => import("./pages/ProvisionalPage.vue"), props: { titleKey: "auth.provisional.privacyTitle" } },
      { path: "/terms", name: "terms", component: () => import("./pages/ProvisionalPage.vue"), props: { titleKey: "auth.provisional.termsTitle" } },
    ],
  });
}

/** Reads the token from the link's fragment, then removes it from the address bar and the history. */
export async function takeFragmentToken(router: Router): Promise<string | null> {
  const match = /(?:^#|&)token=([A-Za-z0-9_-]+)/.exec(window.location.hash);
  const route = router.currentRoute.value;
  await router.replace({ path: route.path, query: route.query, hash: "" });
  return match?.[1] ?? null;
}
